import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { useClearTopicsFilter } from './hooks/useClearTopicsFilter';

export const ClearTopicsFilter: React.FC = () => {
	const {
		data: { hideButton },
		actions: { clearRefine },
	} = useClearTopicsFilter();

	if (hideButton) return null;

	return (
		<Button variant="secondary" onClick={clearRefine} size="small" className="w-full md:w-auto">
			<Translate value="corgi.search.filters.clear_filters.clear" />
		</Button>
	);
};
